export default __webpack_public_path__ + "static/media/thank_you.8bc27896.gif";